import CustomerPortalDispatcher from '../dispatcher/CustomerPortalDispatcher';

import EventEmitter from 'events';
import _ from 'lodash';

let CHANGE_EVENT = 'change';

// ------------------------------- General -------------------------------
// SET VARIABLES HERE
let _user = undefined;
let _header = undefined;
let _language = undefined;
let _errors = undefined;
let _notifications = undefined;
let _broadcastStatus = true;

let _salespersonCustomer = undefined;

let _cusActivity = undefined;

let _transactionData = undefined;
let _transactionSettings = { type: 0, page: 1, perpage: 10 };
let _transactionDate = undefined;

let _orderData = undefined;
let _orderSettings = undefined;
let _orderDate = undefined;
let _orderDrillDown = undefined;
let _orderDetails = {};
let _transactionDetail = undefined;
let _merchantBilling = undefined;

let _payAccountInfo = { total: 0.00, documents: undefined, checked: undefined, checkedDocuments: [] };
let _payAccountDetails = {};
let _prepaymentDocs = undefined;
let _paymentCards = undefined;

let _accountInfo = undefined;
let _customerInfo = undefined;
let _recentInvoice = undefined;
let _recentReceipt = undefined;

let _invoiceError = undefined;
let _invoiceInfo = undefined;
let _invoiceReceipt = undefined;
let _customization = undefined;
let _customizationName = undefined;

class CustomerPortalStore extends EventEmitter {
    constructor() {
        super();
        this.dispatchToken = CustomerPortalDispatcher.register(this.dispatcherCallback.bind(this))
    }
    emitChange() {
        this.emit(CHANGE_EVENT);
    }

    addChangeListener(callback) {
        this.on(CHANGE_EVENT, callback);
    }
    removeChangeListener(callback) {
        this.removeListener(CHANGE_EVENT, callback);
    }
    clearAllData() {
        _errors = undefined;
        _notifications = undefined;
        _header.newLogin = false;
        _salespersonCustomer = undefined;
        _cusActivity = undefined;
        _transactionData = undefined;
        _transactionSettings = {};
        _transactionDate = undefined;
        _orderData = undefined;
        _orderSettings = {};
        _orderDate = undefined;
        _orderDrillDown = undefined;
        _orderDetails = {};
        _transactionDetail = undefined;
        _merchantBilling = undefined;
        _payAccountInfo = { total: 0.00, documents: undefined };
        _payAccountDetails = {};
        _paymentCards = undefined;
        _accountInfo = undefined;
        _customerInfo = undefined;
        _recentInvoice = undefined;
        _recentReceipt = undefined;
        _invoiceError = undefined;
        _invoiceInfo = undefined;
        _invoiceReceipt = undefined;
        _customization = undefined;
        _customizationName = undefined;
    }

    // ------------------------------- General -------------------------------
    // SET GET METHODS HERE
    getGeneralError() {
        return _errors;
    }
    getNotifications() {
        return _notifications;
    }
    // ---------------------------------------------------------
    getCurrentUser() {
        return _user;
    }
    getCurrentUsersName(){
        return (JSON.parse(localStorage.currentUser || sessionStorage.currentUser || '{}').name) || "";
    }
    getCurrentUserName(){
        return (JSON.parse(localStorage.currentUser || sessionStorage.currentUser || '{}').username) || "";
    }
    getCustomerNumber() {
        if(_salespersonCustomer){
          return (_salespersonCustomer.arCustomerNo)
        } else {
          return (JSON.parse(localStorage.currentUser || sessionStorage.currentUser || '{}').customerNumber) || "";
        }
    }
    getCurrentUserType(){
        return (JSON.parse(localStorage.currentUser || sessionStorage.currentUser || '{}').userType)
    }
    getHeaderLogo() {
        return _header.headerInfo.logo;
    }
    getHeaderInfo() {
        return {
          header: _header,
          salesperson: _salespersonCustomer,
          language: _language,
        };
    }
    getCompanyName() {
        return _header.headerInfo.companyName;
    }
    getERP() {
        return (_header.headerInfo) ? (_header.headerInfo.erp) : ('');
    }
    getAllowPartialPayment(){
      return _header.headerInfo.allowPartialPayment;
    }
    getBroadCastStartDate() {
        return _header.headerInfo.broadcastStartDate;
    }
    getBroadCastEndDate(){
        return _header.headerInfo.broadcastExpiryDate;
    }
    getBroadCastStatus(){
        return _broadcastStatus;
    }
    getBroadCastMessage() {
        return {
            title: _header.headerInfo.broadcastTitle,
            message: _header.headerInfo.broadcastMessage
        };
    }
    getShouldUseCustomTransaction() {
        return false;
    }
    getShouldUseCustomOrder() {
        return false;
    }
    getSalesPersonCustomer(){
      return _salespersonCustomer;
    }
    getActivityCustomerActivity() {
        return _cusActivity;
    }
    getRecentInvoice(){
        return _recentInvoice;
    }
    getRecentReceipt(){
        return _recentReceipt;
    }
    getAccountActivitySetting() {
        let settings = _header.headerInfo.siteSettings;
        return _.find(settings, ['endpoint', "Acitivty"]);
    }
    getInvoiceCustomizeSetting() {
        return _header.headerInfo.siteSettings
    }
    getTransactions() {
        return _transactionData;
    }
    getTransactionSettings() {
        return _transactionSettings;
    }
    getTransactionsUpdateDate() {
        return _transactionDate;
    }
    getOrders() {
        return _orderData;
    }
    getOrderSettings() {
        return _orderSettings;
    }
    getOrderUpdateDate() {
        return _orderDate;
    }
    getOrderDrillDown(){
        return _orderDrillDown;
    }
    getOrderDetails(docNo){
      return _orderDetails[docNo];
    }
    getTransactionDetail() {
        return _transactionDetail;
    }
    getMerchantBillingInfo() {
        return _merchantBilling;
    }
    getPayAccountInfo() {
        return _payAccountInfo;
    }
    getPayAccountDetails(docNo){
      return _payAccountDetails[docNo];
    }
    getPrepayments(){
        return _prepaymentDocs
        // return _.filter(_prepaymentDocs,{docType: "order"})
    }
    getPayAccountChecked() {
        return _.filter(_payAccountInfo.documents, { checked: true });
    }
    getPaymentCards() {
        return _paymentCards;
    }
    getAccountInfo() {
        return _accountInfo;
    }
    getCustomerInfo() {
        return _customerInfo;
    }
    getPaymentInvoiceError() {
        return _invoiceError;
    }
    getPaymentInvoiceInfo() {
        return _invoiceInfo;
    }
    getPaymentInvoiceReceipt() {
        return _invoiceReceipt;
    }
    getCusomization(){
      return _customization;
    }
    getCusomizationName(){
      return _customizationName;
    }
    // --------------------------ACTION METHODS----------------------
    dispatcherCallback(action) {
        //dispatcher call back function
        //console.log(action)
        switch (action.actionType) {
            // ------------------------------- General -------------------------------
            case "RELOAD":
                break;
            case "SET_ERROR":
                _errors = action.errors;
                break;
            case "CLEAR_ERROR":
                _errors = undefined;
                break;
            case 'SET_HEADER':
                _header = action.header;
                if(!localStorage.currentUser){
                  let currentLangeuage = localStorage.language
                  localStorage.language = action.language;
                  _language = action.language;
                  window.translate();
                  if(currentLangeuage != action.language) window.translate();
                } else {
                  _language = (JSON.parse(localStorage.currentUser || sessionStorage.currentUser || '{}').language);
                }
                break;
            case 'SET_LANGUAGE':
                localStorage.language = action.language;
                _language = action.language;
                window.translate();
                break;
            case 'SET_USER_LOGIN':
                _header.login = action.secretKey;
                _header.newLogin = true;
                _header.headerInfo.userName = action.userName;
                _header.features = action.features;
                _user = action.user;
                let currentLangeuage = localStorage.language
                localStorage.language = action.language;
                _language = action.language;
                if(currentLangeuage != action.language) window.translate();
                break;
            case 'USER_LOG_OUT':
                _user = undefined;
                _header.login = undefined;
                _header.headerInfo.userName = undefined;
                _header.features = [];
                this.clearAllData();
                break;
            case 'UPDATE_ACCOUNT_INFO':
                if (!action.errors.error) {
                    let rememberMe = localStorage.currentUser ? true : false;
                    _header.headerInfo.userName = action.name;
                    let user = JSON.parse(localStorage.currentUser || sessionStorage.currentUser);
                    user.name = action.name;
                    if (rememberMe) {
                        localStorage.setItem('currentUser', JSON.stringify(user));
                    } else {
                        sessionStorage.setItem('currentUser', JSON.stringify(user));
                    }
                }
                _errors = action.errors;
                break;
            case 'SET_SALESPERSON_CUSTOMER':
                _salespersonCustomer = action.data;
                _cusActivity = undefined;
                _transactionData = undefined;
                _transactionSettings = {};
                _transactionDate = undefined;
                _orderData = undefined;
                _orderSettings = {};
                _orderDate = undefined;
                _orderDrillDown = undefined;
                _transactionDetail = undefined;
                _merchantBilling = undefined;
                _payAccountInfo = { total: 0.00, documents: undefined };
                _paymentCards = undefined;
                _accountInfo = undefined;
                _customerInfo = undefined;
                break;
            case 'SET_BROADCAST_STATUS':
                _broadcastStatus = action.status;
                break;
            case 'SET_ACTIVITY_CUSTOMER_ACTIVITY':
                _cusActivity = action.data;
                break;
            case 'FETCH_RECENT_INVOICES':
                _recentInvoice = action.data;
                break;
            case 'FETCH_RECENT_RECEIPTS':
                _recentReceipt = action.data;
                break;
            case 'FETCH_TRANSACTIONS':
                _transactionData = action.transactionData;
                _transactionSettings.type = action.type;
                _transactionSettings.page = action.page;
                _transactionSettings.perpage = action.perpage;
                break;
            case 'FETCH_TRANSACTIONS_CM':
                _transactionData = action.data;
                break;
            case 'FETCH_TRANSACTION_SETTING':
                _transactionSettings = { ..._transactionSettings, ...action.transactionSettings };
                break;
            case 'FETCH_TRANSACTION_UPDATE_DATE':
                _transactionDate = action.data;
                break;
            case 'FETCH_ORDERS':
                _orderData = action.orderData;
                _orderSettings.doctype = action.doctype;
                _orderSettings.page = action.page;
                _orderSettings.perpage = action.perpage;
                _orderSettings.viewby = action.viewby;
                _orderData.viewby = action.viewby;
                break;
            case 'FETCH_ORDERS_CM':
                _orderData = action.data;
                break;
            case 'FETCH_ORDER_SETTING':
                _orderSettings = { ..._orderSettings, ...action.orderSettings };
                break;
            case 'FETCH_ORDER_UPDATE_DATE':
                _orderDate = action.data;
                break;
            case 'SET_ORDER_DRILL_DOWN':
                _orderDrillDown = action.data;
                break;
            case 'FETCH_ORDER_DETAILS':
                _orderDetails[action.docNo] = action.data;
                break;
            case 'FETCH_TRANSACTION_DETAIL':
                _transactionDetail = action.transactionDetail;
                break;
            case 'FETCH_MERCHANT_BILLING':
                _merchantBilling = action.merchantBilling;
                break;
            case 'FETCH_PAY_ACCOUNT_INFO':
                if (!_payAccountInfo.documents) _payAccountInfo.documents = {};
                _payAccountInfo.ready = true;
                action.documents.forEach((doc, key) => {
                    _payAccountInfo.documents[doc.docNo] = { ..._payAccountInfo.documents[doc.docNo], ...doc };
                })
                _payAccountInfo.useStoredCard = action.useStoredCard;
                _payAccountInfo.makePaymentMessage = action.makePaymentMessage;
                _payAccountInfo.maxPaymentAmount = action.maxPaymentAmount;
                _payAccountInfo.allowPayments = action.allowPayments;
                _payAccountInfo.allowOrderPayments = action.allowOrderPayments;
                _payAccountInfo.allowQuotePayments = action.allowQuotePayments;
                _payAccountInfo.customerCurrency = action.customerCurrency;
                _payAccountInfo.surchargeMessage = action.surchargeMessage;
                _payAccountInfo.allowUnallocatedPayments = action.allowUnallocatedPayments;
                let paymentType = _.sortBy(action.paymentType, function (elem) { return (elem == 'Credit Card' ? -1 : 1) });
                _payAccountInfo.paymentType = paymentType;
                if (action.reset) {
                    _.forEach(_payAccountInfo.documents, ((doc, key) => {
                        doc.checked = false;
                    }));
                    _payAccountInfo.total = 0;
                }
                break;
            case 'FETCH_PAY_ACCOUNT_DETAILS':
                _payAccountDetails[action.docNo] = action.data;
                break;
            case 'LOCAL_UPDATE_PAY_ACCOUNT_SELECTION':{
                let docNo = action.docNo;
                if (_payAccountInfo.documents[docNo]) {
                    _payAccountInfo.documents[docNo].checked = !_payAccountInfo.documents[docNo].checked;
                    if(!_payAccountInfo.selectedCurrency) _payAccountInfo.selectedCurrency = _payAccountInfo.documents[docNo].currencyCode;
                    let checked = _payAccountInfo.documents[docNo].checked;
                    let amountDue = 0;
                    if (_payAccountInfo.documents[docNo].currentAmt) {
                        if(checked){
                            let total = parseFloat(_payAccountInfo.documents[docNo].currentAmt.replace(/[^\d.]/g, ''));
                            amountDue = total;
                            _payAccountInfo.documents[docNo].input = total;
                        } else { //uncheck
                            amountDue = (_payAccountInfo.documents[docNo].input * -1);
                            _payAccountInfo.documents[docNo].input = 0;
                        }
                    }
                    _payAccountInfo.total += amountDue;
                }
                break;
            }
            case 'LOCAL_UPDATE_PAY_ACCOUNT_TOTAL': {
                let docNo = action.docNo;
                if (_payAccountInfo.documents[docNo]) {
                    let amount = _payAccountInfo.documents[docNo].input;
                    _payAccountInfo.documents[docNo].input = action.input;
                    _payAccountInfo.total = _payAccountInfo.total - (amount) + (action.input);
                }
                break;
            }
            case 'LOCAL_SELECT_ALL_PAY': {
                let amountDue = 0;
                _.forEach(_payAccountInfo.documents, ((value, key) => {
                    if(value.payable){
                      value.checked = action.selectAll;
                      if (action.selectAll) {
                        let total = parseFloat(value.currentAmt.replace(/[^\d.]/g, ''));
                        value.input = total;
                        amountDue += total;
                      } else {
                        value.input = 0;
                      }
                    }
                }));
                _payAccountInfo.total = amountDue;
                break;
            }
            case 'FETCH_PAYMENT_CARDS':
                _paymentCards = action.paymentCards;
                _errors = undefined;
                break;
            case 'ADD_NEW_PAYMENT_CARD':
                _paymentCards.push(action.paymentCard);
                _errors = undefined;
                break;
            case 'SET_PAYMENT_TO_DEFAULT': {
                let index = _.findIndex(_paymentCards, 'defaultCard');
                let curIndex = _.findIndex(_paymentCards, { 'cardId': action.id });
                if (_paymentCards[index]) {
                    _paymentCards[index].defaultCard = false;
                }
                _paymentCards[curIndex].defaultCard = true;
                break;
            }
            case "DELETE_PAYMENT_CARD": {
                let index = _.findIndex(_paymentCards, { 'cardId': action.id });
                _paymentCards.splice(index, 1);
                break;
            }
            case "RESET_PREPAYMENT":{
                _prepaymentDocs = undefined;
                break;
            }
            case "FETCH_PREPAYMENT": {
              if (!_prepaymentDocs) _prepaymentDocs = {};
              action.documents.forEach((doc, key) => {
                  _prepaymentDocs[doc.docNo] = { ..._prepaymentDocs[doc.docNo], ...doc };
              });
              _payAccountInfo.ready = true;
              _payAccountInfo.useStoredCard = action.useStoredCard;
              _payAccountInfo.makePaymentMessage = action.makePaymentMessage;
              _payAccountInfo.maxPaymentAmount = action.maxPaymentAmount;
              _payAccountInfo.allowPayments = action.allowPayments;
              _payAccountInfo.surchargeMessage = action.surchargeMessage;
              _payAccountInfo.allowOrderPayments  = action.allowOrderPayments;
              _payAccountInfo.allowQuotePayments = action.allowQuotePayments;
              _payAccountInfo.allowUnallocatedPayments = action.allowUnallocatedPayments;
              _payAccountInfo.customerCurrency = action.customerCurrency;
              let paymentType = _.sortBy(action.paymentType, function (elem) { return (elem == 'Credit Card' ? -1 : 1) });
              _payAccountInfo.paymentType = paymentType;
              if (action.reset) {
                  _.forEach(_payAccountInfo.documents, ((doc, key) => {
                      doc.checked = false;
                  }));
                  _payAccountInfo.total = 0;
              }
              break;
            }
            case 'OVERALL_PAYMENT_SETTINGS':
                _payAccountInfo.customerCurrency = action.currency;
                _payAccountInfo.allowPayments = action.data.allowPayments;
                _payAccountInfo.paymentType = action.data.paymentRates;
                _payAccountInfo.useStoredCard = action.data.useStoredCard;
                break;
            case "LOCAL_UPDATE_PREPAY":{
              let docNo = action.docNo;
              if (_prepaymentDocs[docNo]) {
                  _prepaymentDocs[docNo].checked = !_prepaymentDocs[docNo].checked;
                  _prepaymentDocs[docNo].input = (_prepaymentDocs[docNo].checked)?(_prepaymentDocs[docNo].currentAmt):(0);
              }
              break;
            }
            case "LOCAL_UPDATE_PREPAY_TOTAL":{
              let docNo = action.docNo;
              if (_prepaymentDocs[docNo]) {
                  _prepaymentDocs[docNo].input = action.input;
              }
              break;
            }
            case "LOCAL_SELECT_ALL_PREPAY":{
              let amountDue = 0;
              _.forEach(_.filter(_prepaymentDocs,{docType: action.type}), ((value, key) => {
                  value.checked = action.selectAll;
              }));
              break;
            }
            case "INSERT_PREPAYMENT":{
              if(!_prepaymentDocs) _prepaymentDocs = {};
              _prepaymentDocs['unapplied'] = {
                customerNo: this.getCustomerNumber(),
                docNo: action.transaction.reference,
                input: action.transaction.amount,
                docType: "unapplied",
                checked: true
              }
              break;
            }
            case "RESET_PASSWORD_FIELD":
                _errors = undefined;
                break;
            case "FETCH_MY_ACCOUNT_INFO":
                _accountInfo = action.accountInfo;
                break;
            case "UPDATE_MY_ACCOUNT_INFO":
                _accountInfo = { ..._accountInfo, ...action.accountInfo };
                break;
            case 'SET_CUSTOMER_INFO':
                _customerInfo = action.customerInfo;
                _customerInfo.message = '';
                break;
            case 'RESET_CUSTOMER_INFO':
                _customerInfo.message = '';
                _errors = undefined;
                break;
            case 'FETCH_PAYMENT_INVOICE_ERROR':
                _invoiceError = action.error;
                break;
            case 'FETCH_PAYMENT_INVOICE_INFO':
                _invoiceInfo = action.invoiceInfo;
                break;
            case 'FETCH_PAYMENT_INVOICE_RECEIPT':
                _invoiceReceipt = action.data;
                break;
            case 'FETCH_CUSTOMIZATION':
                _customization = action.content;
                _customizationName = action.name;
                break;
            default:
                break;
        }
        this.emitChange();
        return true;
    }
};

export default new CustomerPortalStore();
